import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, Tooltip } from "@mui/material";
import SettingToggleTextarea from "components/shared/SettingToggleTextarea";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface DefaultSignerBlockProps {
    defaultSignatureEnabled: boolean;
    persistedGlobalText: string;
    defaultExpanded: boolean | undefined;
    onToggle: (enabled: boolean) => void;
    onSave: (value: string) => void;
    onSetExpanded: (val: boolean) => void;
}

const DefaultSignerBlock = ({
    defaultSignatureEnabled,
    persistedGlobalText,
    defaultExpanded,
    onToggle,
    onSave,
    onSetExpanded,
}: DefaultSignerBlockProps) => {
    const [t] = useTranslation();
    const hasDefaultText = defaultSignatureEnabled && !!persistedGlobalText.trim();
    const isDefaultExpanded = defaultExpanded ?? !hasDefaultText;

    return (
        <div className={styles["template-signer-block"]}>
            <div className={styles["template-signer-header"]}>
                <span className={styles["template-signer-name"]}>
                    {t("ContractSettingsPreferences.DefaultSignature")}
                </span>
                {hasDefaultText && (
                    <Tooltip title={t("ContractSettingsPreferences.PreviewText")}>
                        <IconButton size="small" onClick={() => onSetExpanded(!isDefaultExpanded)}>
                            <VisibilityOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
            <SettingToggleTextarea
                title={t("ContractSettingsPreferences.SignerBlockTitleDefault")}
                description={t("ContractSettingsPreferences.SignerBlockDescriptionDefault")}
                enabled={defaultSignatureEnabled}
                persistedValue={persistedGlobalText}
                onToggle={onToggle}
                onSave={onSave}
                rows={5}
                maxLength={500}
                expanded={defaultSignatureEnabled ? isDefaultExpanded : undefined}
            />
        </div>
    );
};

export default DefaultSignerBlock;
